module.exports = __webpack_public_path__ + "static/media/UN0579231.f46322db.jpg";